import { message } from "antd";

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  message.success("Booking ID copied to clipboard");
};
